import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NotePencilRegular from './note-pencil-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NotePencilRegular {...validProps} />;
}
SvgComponent.iconName = 'notePencilRegular';

export const NotePencilRegularIcon = svgIconWrapper(SvgComponent);
